import {   GetBritamStatisticsResponse} from "Application/models";
import { APICallInstance } from "./APICallInstance";
import { AxiosResponse } from "axios";



export const fetchBritamStatistics = async (regionName:string) => {
    const url = `api/v1/statistic/travel?regionName=${regionName}`;

    try {
        const response: AxiosResponse<GetBritamStatisticsResponse> = await APICallInstance.get(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};



